// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1pjW0","consentsList":"PatientConsents_consentsList__2XnOG","consentsListEmpty":"PatientConsents_consentsListEmpty__3BIcQ"};